import IAction from "../../types/IAction";
import actionTypes from "../actionTypes";
import constants from "../../utils/constants";
import axios from "axios";
import FileDownload from "js-file-download";
import { errorNotification } from "../../utils/notifications";
import MembresiaPlantilla, {
  MembresiaMeta
} from "../../types/MembresiaPlantilla";
import MembresiaTrackingClub from "../../types/MembresiaTrackingClub";
import MembresiaTrackingClubCompromisos from "../../types/MembresiaTrackingClubCompromisos";
import MembresiaTrackingAsesor from "../../types/MembresiaTrackingAsesor";
import { TipoComision } from "../../types/ComisionAlcance";
import { deleteEmptyProps } from "../../toolkit/utils/filter-utils";

const COMISION_MEMBRESIA_BASE_URL = "/api/comisiones-membresia";

export const postCargaMetas = (
  formData: FormData,
  confirmar: boolean
): IAction => {
  return {
    type: actionTypes.POST_COMISION_MEMBRESIA_CARGA_METAS,
    payload: axios.post(
      `${constants.BASE_URL}${COMISION_MEMBRESIA_BASE_URL}/meta-carga`,
      formData,
      {
        withCredentials: true,
        params: { confirmar }
      }
    ),
    meta: {
      resolver: Promise.resolve
    }
  };
};

export const getMetas = (): IAction => {
  return {
    type: actionTypes.GET_COMISION_MEMBRESIA_METAS,
    payload: axios.get(
      `${constants.BASE_URL}${COMISION_MEMBRESIA_BASE_URL}/meta-carga`,
      {
        withCredentials: true
      }
    ),
    meta: {
      resolver: Promise.resolve
    }
  };
};

export const getMetasActuales = (): IAction => {
  return {
    type: actionTypes.GET_COMISION_MEMBRESIA_METAS_ACTUALES,
    payload: axios.get(
      `${constants.BASE_URL}${COMISION_MEMBRESIA_BASE_URL}/metas-actuales`,
      {
        withCredentials: true
      }
    ),
    meta: {
      resolver: Promise.resolve
    }
  };
};

export const clearMetas = (): IAction => {
  return {
    type: actionTypes.CLEAR_COMISION_MEMBRESIA_METAS,
    payload: true
  };
};

export const downloadMetasArchivo = (callback?: (error?) => void) => {
  return axios
    .get(
      `${constants.BASE_URL}${COMISION_MEMBRESIA_BASE_URL}/meta-carga/download`,
      {
        withCredentials: true,
        responseType: "blob"
      }
    )
    .then(({ data }) => {
      FileDownload(data, "metas-membresia.xlsx");
      callback && callback();
    })
    .catch(error => {
      errorNotification("Error al descargar el archivo");
      callback && callback(error);
    });
};

export const getPlantillaByPeriodo = (periodo: string): IAction => {
  return {
    type: actionTypes.GET_COMISION_MEMBRESIA_PLANTILLA,
    payload: axios.get(
      `${constants.BASE_URL}${COMISION_MEMBRESIA_BASE_URL}/plantilla`,
      {
        withCredentials: true,
        params: { periodo }
      }
    ),
    meta: {
      resolver: Promise.resolve
    }
  };
};

export const postPlantilla = (plantilla: MembresiaPlantilla): IAction => {
  return {
    type: actionTypes.POST_COMISION_MEMBRESIA_PLANTILLA,
    payload: axios.post(
      `${constants.BASE_URL}${COMISION_MEMBRESIA_BASE_URL}/plantilla`,
      plantilla,
      {
        withCredentials: true
      }
    ),
    meta: {
      resolver: Promise.resolve
    }
  };
};

export const confirmarPlantilla = (id: number): IAction => {
  return {
    type: actionTypes.POST_COMISION_MEMBRESIA_PLANTILLA_CONFIRMAR,
    payload: axios.post(
      `${constants.BASE_URL}${COMISION_MEMBRESIA_BASE_URL}/plantilla/${id}/confirmar`,
      {},
      {
        withCredentials: true
      }
    ),
    meta: {
      resolver: Promise.resolve
    }
  };
};

export const deletePlantillaByPeriodo = (periodo: string): IAction => {
  return {
    type: actionTypes.DELETE_COMISION_MEMBRESIA_PLANTILLA,
    payload: axios.delete(
      `${constants.BASE_URL}${COMISION_MEMBRESIA_BASE_URL}/plantilla`,
      {
        withCredentials: true,
        params: { periodo }
      }
    ),
    meta: {
      resolver: Promise.resolve
    }
  };
};

export const downloadReporteMetasClub = (
  periodo: string,
  callback?: (error?) => void
) => {
  return axios
    .get(
      `${constants.BASE_URL}${COMISION_MEMBRESIA_BASE_URL}/plantilla/reporte-metas-club`,
      {
        withCredentials: true,
        responseType: "blob",
        params: { periodo }
      }
    )
    .then(({ data }) => {
      FileDownload(data, `metas_por_club_${periodo}.xlsx`);
      callback && callback();
    })
    .catch(error => {
      errorNotification("Error al descargar el reporte");
      callback && callback(error);
    });
};

export const putRegionMetas = (
  idRegion: number,
  metas: MembresiaMeta
): IAction => {
  return {
    type: actionTypes.PUT_COMISION_MEMBRESIA_REGION_METAS,
    payload: axios.put(
      `${constants.BASE_URL}${COMISION_MEMBRESIA_BASE_URL}/plantilla/region/${idRegion}/metas`,
      metas,
      {
        withCredentials: true
      }
    ),
    meta: {
      resolver: Promise.resolve
    }
  };
};

export const putClubMetas = (
  idLider: number,
  metas: MembresiaMeta
): IAction => {
  return {
    type: actionTypes.PUT_COMISION_MEMBRESIA_CLUB_METAS,
    payload: axios.put(
      `${constants.BASE_URL}${COMISION_MEMBRESIA_BASE_URL}/plantilla/club/${idLider}/metas`,
      metas,
      {
        withCredentials: true
      }
    ),
    meta: {
      resolver: Promise.resolve
    }
  };
};

export const putAsesoresMetas = (
  idLider: number,
  metas: MembresiaMeta
): IAction => {
  return {
    type: actionTypes.PUT_COMISION_MEMBRESIA_ASESORES_METAS,
    payload: axios.put(
      `${constants.BASE_URL}${COMISION_MEMBRESIA_BASE_URL}/plantilla/club/${idLider}/asesores/metas`,
      metas,
      {
        withCredentials: true
      }
    ),
    meta: {
      resolver: Promise.resolve
    }
  };
};

export const getComisionAlcanceByTipos = (): IAction => {
  const tiposComision = [
    TipoComision.ASESOR_VENTA,
    TipoComision.ASESOR_REACTIVACION,
    TipoComision.ASESOR_INTEGRANTE,
    TipoComision.LIDER_COMERCIAL_VENTA,
    TipoComision.LIDER_COMERCIAL_REACTIVACION,
    TipoComision.LIDER_COMERCIAL_INTEGRANTE,
    TipoComision.LIDER_COMERCIAL_BONO_CONSOLIDADO,
    TipoComision.GERENTE_REGIONAL_BONO_CONSOLIDADO
  ];

  return {
    type: actionTypes.GET_COMISION_MEMBRESIA_ALCANCES,
    payload: axios.get(
      `${constants.BASE_URL}${COMISION_MEMBRESIA_BASE_URL}/alcance/tipos-comision`,
      {
        withCredentials: true,
        params: { tipos: tiposComision.join(",") }
      }
    ),
    meta: {
      resolver: Promise.resolve
    }
  };
};

export const clearSnapshot = (): IAction => {
  return {
    type: actionTypes.CLEAR_COMISION_MEMBRESIA_SNAPSHOT,
    payload: true
  };
};

export const getSnapshotByFolioFactura = (
  folioFactura: string,
  page: number,
  size: number
): IAction => {
  return {
    type: actionTypes.GET_COMISION_MEMBRESIA_SNAPSHOT_BY_FOLIO,
    payload: axios.get(
      `${constants.BASE_URL}${COMISION_MEMBRESIA_BASE_URL}/snapshot/facturas`,
      {
        withCredentials: true,
        params: { folioFactura, page, size }
      }
    ),
    meta: {
      resolver: Promise.resolve
    }
  };
};

export const getSnapshotByPeriodo = (
  periodo: string,
  idClub?: number,
  tipoOperacion?: string,
  conCambios?: boolean,
  evaluadorModifico?: boolean,
  sinCumplimiento?: boolean,
  page?: number,
  size?: number
): IAction => {
  return {
    type: actionTypes.GET_COMISION_MEMBRESIA_SNAPSHOT_BY_PERIODO,
    payload: axios.get(
      `${constants.BASE_URL}${COMISION_MEMBRESIA_BASE_URL}/snapshot/periodos`,
      {
        withCredentials: true,
        params: {
          periodo,
          idClub,
          tipoOperacion,
          conCambios,
          evaluadorModifico,
          sinCumplimiento,
          page,
          size
        }
      }
    ),
    meta: {
      resolver: Promise.resolve
    }
  };
};

export const getSnapshotByAsesor = (
  periodo: string,
  idVendedor: number,
  page: number,
  size: number,
  tipoOperacion?: string
): IAction => {
  return {
    type: actionTypes.GET_COMISION_MEMBRESIA_SNAPSHOT_BY_ASESOR,
    payload: axios.get(
      `${constants.BASE_URL}${COMISION_MEMBRESIA_BASE_URL}/snapshot/asesores`,
      {
        withCredentials: true,
        params: deleteEmptyProps({
          periodo,
          idVendedor,
          page,
          size,
          tipoOperacion
        })
      }
    ),
    meta: {
      resolver: Promise.resolve
    }
  };
};

export const postSnapshotByPeriodo = (periodo: string): IAction => {
  return {
    type: actionTypes.POST_COMISION_MEMBRESIA_SNAPSHOT_BY_PERIODO,
    payload: axios.post(
      `${constants.BASE_URL}${COMISION_MEMBRESIA_BASE_URL}/snapshot/periodos`,
      null,
      {
        withCredentials: true,
        params: { periodo }
      }
    ),
    meta: {
      resolver: Promise.resolve
    }
  };
};

export const putSnapshotEvaluacion = (
  idCotizacionItem: number,
  actualizacion: any
): IAction => {
  return {
    type: actionTypes.PUT_COMISION_MEMBRESIA_SNAPSHOT_EVALUACION,
    payload: axios.put(
      `${constants.BASE_URL}${COMISION_MEMBRESIA_BASE_URL}/snapshot/evaluacion/${idCotizacionItem}`,
      deleteEmptyProps(actualizacion),
      {
        withCredentials: true
      }
    ),
    meta: {
      resolver: Promise.resolve
    }
  };
};

export const deleteSnapshotEvaluacion = (idCotizacionItem: number): IAction => {
  return {
    type: actionTypes.DELETE_COMISION_MEMBRESIA_SNAPSHOT_EVALUACION,
    payload: axios.delete(
      `${constants.BASE_URL}${COMISION_MEMBRESIA_BASE_URL}/snapshot/descartar-cambios/${idCotizacionItem}`,
      {
        withCredentials: true
      }
    ),
    meta: {
      resolver: Promise.resolve
    }
  };
};

export const downloadSnapshotByFolioFactura = (
  folioFactura: string,
  callback: any
) => {
  axios
    .get(
      `${constants.BASE_URL}${COMISION_MEMBRESIA_BASE_URL}/snapshot/facturas/descargar`,
      {
        withCredentials: true,
        params: { folioFactura }
      }
    )
    .then(({ data }) => {
      FileDownload(data, `Membresias.csv`);
      callback && callback();
    })
    .catch(error => {
      errorNotification("No se pudo descargar el reporte");
      callback && callback(error);
    });
};

export const downloadSnapshotByPeriodo = (
  periodo: string,
  idClub: number,
  tipoOperacion: string,
  conCambios: boolean,
  evaluadorModifico: boolean,
  sinCumplimiento: boolean,
  callback: any
) => {
  axios
    .get(
      `${constants.BASE_URL}${COMISION_MEMBRESIA_BASE_URL}/snapshot/periodos/descargar`,
      {
        withCredentials: true,
        params: {
          periodo,
          idClub,
          tipoOperacion,
          conCambios,
          evaluadorModifico,
          sinCumplimiento
        }
      }
    )
    .then(({ data }) => {
      FileDownload(data, `Membresias.csv`);
      callback && callback();
    })
    .catch(error => {
      errorNotification("No se pudo descargar el reporte");
      callback && callback(error);
    });
};

export const downloadSnapshotByAsesor = (
  periodo: string,
  idVendedor: number,
  callback: any
) => {
  axios
    .get(
      `${constants.BASE_URL}${COMISION_MEMBRESIA_BASE_URL}/snapshot/asesores/descargar`,
      {
        withCredentials: true,
        params: { periodo, idVendedor }
      }
    )
    .then(({ data }) => {
      FileDownload(data, `Membresias.csv`);
      callback && callback();
    })
    .catch(error => {
      errorNotification("No se pudo descargar el reporte");
      callback && callback(error);
    });
};

export const clearResumen = (): IAction => {
  return {
    type: actionTypes.CLEAR_COMISION_MEMBRESIA_RESUMEN,
    payload: true
  };
};

export const getResumenByPeriodo = (periodo: string): IAction => {
  return {
    type: actionTypes.GET_COMISION_MEMBRESIA_RESUMEN_BY_PERIODO,
    payload: axios.get(
      `${constants.BASE_URL}${COMISION_MEMBRESIA_BASE_URL}/snapshot/periodos/${periodo}/resumen`,
      {
        withCredentials: true
      }
    ),
    meta: {
      resolver: Promise.resolve
    }
  };
};

export const getResumenByPeriodoAndIdClub = (
  periodo: string,
  idClub: number
): IAction => {
  return {
    type: actionTypes.GET_COMISION_MEMBRESIA_RESUMEN_BY_PERIODO_CLUB,
    payload: axios.get(
      `${constants.BASE_URL}${COMISION_MEMBRESIA_BASE_URL}/snapshot/periodos/${periodo}/clubes/${idClub}/resumen`,
      {
        withCredentials: true
      }
    ),
    meta: {
      resolver: Promise.resolve
    }
  };
};

export const getClubesByLider = (
  periodo: string,
  idLider?: number
): IAction => {
  return {
    type: actionTypes.GET_COMISION_MEMBRESIA_LIDER_CLUBES,
    payload: axios.get(
      `${constants.BASE_URL}${COMISION_MEMBRESIA_BASE_URL}/snapshot/lideres/clubes`,
      {
        withCredentials: true,
        params: deleteEmptyProps({ periodo, idLider })
      }
    ),
    meta: {
      resolver: Promise.resolve
    }
  };
};

export const getReporteByLiderClub = (
  periodo: string,
  idClub: number,
  idLider?: number
): IAction => {
  return {
    type: actionTypes.GET_COMISION_MEMBRESIA_LIDER_REPORTE,
    payload: axios.get(
      `${constants.BASE_URL}${COMISION_MEMBRESIA_BASE_URL}/snapshot/lideres/reporte`,
      {
        withCredentials: true,
        params: deleteEmptyProps({ periodo, idClub, idLider })
      }
    ),
    meta: {
      resolver: Promise.resolve
    }
  };
};

export const getResumenByAsesor = (
  periodo: string,
  idVendedor?: number
): IAction => {
  return {
    type: actionTypes.GET_COMISION_MEMBRESIA_RESUMEN_BY_ASESOR,
    payload: axios.get(
      `${constants.BASE_URL}${COMISION_MEMBRESIA_BASE_URL}/snapshot/asesores/resumen`,
      {
        withCredentials: true,
        params: deleteEmptyProps({ periodo, idVendedor })
      }
    ),
    meta: {
      resolver: Promise.resolve
    }
  };
};

export const putCambiarVendedor = (
  idCotizacionItem: number,
  request: any
): IAction => {
  return {
    type: actionTypes.PUT_COMISION_MEMBRESIA_CAMBIAR_VENDEDOR,
    payload: axios.put(
      `${constants.BASE_URL}${COMISION_MEMBRESIA_BASE_URL}/snapshot/cambiar-vendedor/${idCotizacionItem}`,
      request,
      {
        withCredentials: true
      }
    ),
    meta: {
      resolver: Promise.resolve
    }
  };
};

export const getEstadoProceso = (periodo: string): IAction => {
  return {
    type: actionTypes.GET_COMISION_MEMBRESIA_PROCESO_ESTADO,
    payload: axios.get(
      `${constants.BASE_URL}${COMISION_MEMBRESIA_BASE_URL}/proceso`,
      {
        withCredentials: true,
        params: { periodo }
      }
    ),
    meta: {
      resolver: Promise.resolve
    }
  };
};

export const postCalcularAlcances = (periodo: string): IAction => {
  return {
    type: actionTypes.POST_COMISION_MEMBRESIA_PROCESO_CALCULAR_ALCANCES,
    payload: axios.post(
      `${constants.BASE_URL}${COMISION_MEMBRESIA_BASE_URL}/proceso/calcular-alcances`,
      null,
      {
        withCredentials: true,
        params: { periodo }
      }
    ),
    meta: {
      resolver: Promise.resolve
    }
  };
};

export const postConfirmarAlcances = (periodo: string): IAction => {
  return {
    type: actionTypes.POST_COMISION_MEMBRESIA_PROCESO_CONFIRMAR_ALCANCES,
    payload: axios.post(
      `${constants.BASE_URL}${COMISION_MEMBRESIA_BASE_URL}/proceso/confirmar-alcances`,
      null,
      {
        withCredentials: true,
        params: { periodo }
      }
    ),
    meta: {
      resolver: Promise.resolve
    }
  };
};

export const postPrecalculo = (
  periodo: string,
  tipoProceso: string
): IAction => {
  return {
    type: actionTypes.POST_COMISION_MEMBRESIA_PROCESO_PRECALCULO,
    payload: axios.post(
      `${constants.BASE_URL}${COMISION_MEMBRESIA_BASE_URL}/proceso/precalculo`,
      null,
      {
        withCredentials: true,
        params: { periodo, tipoProceso }
      }
    ),
    meta: {
      resolver: Promise.resolve
    }
  };
};

export const postCalcularComisiones = (
  periodo: string,
  tipoProceso: string
): IAction => {
  return {
    type: actionTypes.POST_COMISION_MEMBRESIA_PROCESO_CALCULAR_COMISIONES,
    payload: axios.post(
      `${constants.BASE_URL}${COMISION_MEMBRESIA_BASE_URL}/proceso/calcular-comisiones`,
      null,
      {
        withCredentials: true,
        params: { periodo, tipoProceso }
      }
    ),
    meta: {
      resolver: Promise.resolve
    }
  };
};

export const downloadReportePrecalculo = (
  periodo: string,
  tipoProceso: string,
  callback?: (error?) => void
) => {
  return axios
    .get(
      `${constants.BASE_URL}${COMISION_MEMBRESIA_BASE_URL}/proceso/reporte-precalculo`,
      {
        withCredentials: true,
        responseType: "blob",
        params: { periodo, tipoProceso }
      }
    )
    .then(({ data }) => {
      const filename = `Precalculo_${tipoProceso}_${periodo}.xlsx`;
      FileDownload(data, filename);
      callback && callback();
    })
    .catch(error => {
      errorNotification("Error al descargar el reporte de precálculo");
      callback && callback(error);
    });
};

export const downloadReporteAlcances = (
  periodo: string,
  callback?: (error?) => void
) => {
  return axios
    .get(
      `${constants.BASE_URL}${COMISION_MEMBRESIA_BASE_URL}/proceso/reporte-alcances`,
      {
        withCredentials: true,
        responseType: "blob",
        params: { periodo }
      }
    )
    .then(({ data }) => {
      const filename = `Alcances_${periodo}.xlsx`;
      FileDownload(data, filename);
      callback && callback();
    })
    .catch(error => {
      errorNotification("Error al descargar el reporte de alcances");
      callback && callback(error);
    });
};

export const downloadReporteComisiones = (
  fechaPago: string,
  callback?: (error?) => void
) => {
  return axios
    .get(
      `${constants.BASE_URL}${COMISION_MEMBRESIA_BASE_URL}/proceso/reporte-comisiones`,
      {
        withCredentials: true,
        responseType: "blob",
        params: { fechaPago }
      }
    )
    .then(({ data }) => {
      const filename = `Comisiones_${fechaPago}.xlsx`;
      FileDownload(data, filename);
      callback && callback();
    })
    .catch(error => {
      errorNotification("Error al descargar el reporte de comisiones");
      callback && callback(error);
    });
};

export const getEmpleadosDadosDeBaja = (periodo: string): IAction => {
  return {
    type: actionTypes.GET_COMISION_MEMBRESIA_EMPLEADOS_BAJA,
    payload: axios.get(
      `${constants.BASE_URL}${COMISION_MEMBRESIA_BASE_URL}/plantilla/empleados-baja`,
      {
        withCredentials: true,
        params: { periodo }
      }
    ),
    meta: {
      resolver: Promise.resolve
    }
  };
};

export const downloadReportePagoAnticipado = (
  periodo: string,
  idEmpleado: number,
  tipoEmpleado: string,
  callback?: (error?) => void
) => {
  return axios
    .post(
      `${constants.BASE_URL}${COMISION_MEMBRESIA_BASE_URL}/plantilla/pago-anticipado`,
      null,
      {
        withCredentials: true,
        responseType: "blob",
        params: { periodo, idEmpleado, tipoEmpleado }
      }
    )
    .then(({ data }) => {
      const filename = `PagoAnticipado_${periodo}_${idEmpleado}_${tipoEmpleado}.xlsx`;
      FileDownload(data, filename);
      callback && callback();
    })
    .catch(error => {
      errorNotification("Error al generar el reporte de pago anticipado");
      callback && callback(error);
    });
};

export const deletePagoAnticipado = (
  periodo: string,
  idEmpleado: number,
  tipoEmpleado: string
): IAction => {
  return {
    type: actionTypes.DELETE_COMISION_MEMBRESIA_PAGO_ANTICIPADO,
    payload: axios.delete(
      `${constants.BASE_URL}${COMISION_MEMBRESIA_BASE_URL}/plantilla/pago-anticipado`,
      {
        withCredentials: true,
        params: { periodo, idEmpleado, tipoEmpleado }
      }
    ),
    meta: {
      resolver: Promise.resolve
    }
  };
};

export const getTiposMembresiaOpciones = (tipoOperacion: string): IAction => {
  return {
    type: actionTypes.GET_COMISION_MEMBRESIA_TIPOS_MEMBRESIA_OPCIONES,
    payload: axios.get(
      `${constants.BASE_URL}${COMISION_MEMBRESIA_BASE_URL}/snapshot/tipos-membresia/opciones`,
      {
        withCredentials: true,
        params: { tipoOperacion }
      }
    ),
    meta: {
      resolver: Promise.resolve
    }
  };
};

export const deleteCalcularAlcances = (periodo: string): IAction => {
  return {
    type: actionTypes.DELETE_COMISION_MEMBRESIA_PROCESO_CALCULAR_ALCANCES,
    payload: axios.delete(
      `${constants.BASE_URL}${COMISION_MEMBRESIA_BASE_URL}/proceso/calcular-alcances`,
      {
        withCredentials: true,
        params: { periodo }
      }
    ),
    meta: {
      resolver: Promise.resolve
    }
  };
};

export const deleteConfirmarAlcances = (periodo: string): IAction => {
  return {
    type: actionTypes.DELETE_COMISION_MEMBRESIA_PROCESO_CONFIRMAR_ALCANCES,
    payload: axios.delete(
      `${constants.BASE_URL}${COMISION_MEMBRESIA_BASE_URL}/proceso/confirmar-alcances`,
      {
        withCredentials: true,
        params: { periodo }
      }
    ),
    meta: {
      resolver: Promise.resolve
    }
  };
};

export const deletePrecalculo = (
  periodo: string,
  tipoProceso: string
): IAction => {
  return {
    type: actionTypes.DELETE_COMISION_MEMBRESIA_PROCESO_PRECALCULO,
    payload: axios.delete(
      `${constants.BASE_URL}${COMISION_MEMBRESIA_BASE_URL}/proceso/precalculo`,
      {
        withCredentials: true,
        params: { periodo, tipoProceso }
      }
    ),
    meta: {
      resolver: Promise.resolve
    }
  };
};

export const deleteCalcularComisiones = (
  periodo: string,
  tipoProceso: string
): IAction => {
  return {
    type: actionTypes.DELETE_COMISION_MEMBRESIA_PROCESO_CALCULAR_COMISIONES,
    payload: axios.delete(
      `${constants.BASE_URL}${COMISION_MEMBRESIA_BASE_URL}/proceso/calcular-comisiones`,
      {
        withCredentials: true,
        params: { periodo, tipoProceso }
      }
    ),
    meta: {
      resolver: Promise.resolve
    }
  };
};

export const getTrackingByPeriodo = (periodo: string): IAction => {
  return {
    type: actionTypes.GET_COMISION_MEMBRESIA_TRACKING,
    payload: axios.get(
      `${constants.BASE_URL}${COMISION_MEMBRESIA_BASE_URL}/tracking/${periodo}`,
      {
        withCredentials: true
      }
    ),
    meta: {
      resolver: Promise.resolve
    }
  };
};

export const postTracking = (
  trackingList: MembresiaTrackingClub[]
): IAction => {
  return {
    type: actionTypes.POST_COMISION_MEMBRESIA_TRACKING,
    payload: axios.post(
      `${constants.BASE_URL}${COMISION_MEMBRESIA_BASE_URL}/tracking`,
      trackingList,
      {
        withCredentials: true
      }
    ),
    meta: {
      resolver: Promise.resolve
    }
  };
};

export const clearTracking = (): IAction => {
  return {
    type: actionTypes.CLEAR_COMISION_MEMBRESIA_TRACKING,
    payload: true
  };
};

export const getTrackingByPeriodoAndClub = (
  periodo: string,
  idClub: number
): IAction => {
  return {
    type: actionTypes.GET_COMISION_MEMBRESIA_TRACKING_CLUB_ALCANCE,
    payload: axios.get(
      `${constants.BASE_URL}${COMISION_MEMBRESIA_BASE_URL}/tracking/${periodo}/club/${idClub}`,
      {
        withCredentials: true
      }
    ),
    meta: {
      resolver: Promise.resolve
    }
  };
};

export const putCompromisoClub = (
  periodo: string,
  idClub: number,
  compromisos: MembresiaTrackingClubCompromisos
): IAction => {
  return {
    type: actionTypes.PUT_COMISION_MEMBRESIA_TRACKING_COMPROMISOS,
    payload: axios.put(
      `${constants.BASE_URL}${COMISION_MEMBRESIA_BASE_URL}/tracking/${periodo}/club/${idClub}/compromisos`,
      compromisos,
      {
        withCredentials: true
      }
    ),
    meta: {
      resolver: Promise.resolve
    }
  };
};

export const putAsesoresTracking = (
  periodo: string,
  idClub: number,
  asesores: MembresiaTrackingAsesor[]
): IAction => {
  return {
    type: actionTypes.PUT_COMISION_MEMBRESIA_TRACKING_ASESORES,
    payload: axios.put(
      `${constants.BASE_URL}${COMISION_MEMBRESIA_BASE_URL}/tracking/${periodo}/club/${idClub}/asesores`,
      asesores,
      {
        withCredentials: true
      }
    ),
    meta: {
      resolver: Promise.resolve
    }
  };
};

// Resoluciones de altas de integrantes
export const postResolucionIntegrante = (resolucion: any): IAction => {
  return {
    type: actionTypes.POST_COMISION_MEMBRESIA_INTEGRANTE_RESOLUCION,
    payload: axios.post(
      `${constants.BASE_URL}${COMISION_MEMBRESIA_BASE_URL}/integrante-resolucion/resoluciones`,
      resolucion,
      {
        withCredentials: true
      }
    ),
    meta: {
      resolver: Promise.resolve
    }
  };
};

export const getCargosByFolioFactura = (folioFactura: string): IAction => {
  return {
    type: actionTypes.GET_COMISION_MEMBRESIA_INTEGRANTE_CARGOS_BY_FOLIO,
    payload: axios.get(
      `${constants.BASE_URL}${COMISION_MEMBRESIA_BASE_URL}/integrante-resolucion/facturas/${folioFactura}`,
      {
        withCredentials: true
      }
    ),
    meta: {
      resolver: Promise.resolve
    }
  };
};

export const getIntegrantesEliminados = (periodo: string): IAction => {
  return {
    type: actionTypes.GET_COMISION_MEMBRESIA_INTEGRANTE_ELIMINADOS,
    payload: axios.get(
      `${constants.BASE_URL}${COMISION_MEMBRESIA_BASE_URL}/integrante-resolucion/integrantes-eliminados`,
      {
        withCredentials: true,
        params: { periodo }
      }
    ),
    meta: {
      resolver: Promise.resolve
    }
  };
};

export const getAltasEnMembresiasExistentes = (periodo: string): IAction => {
  return {
    type: actionTypes.GET_COMISION_MEMBRESIA_INTEGRANTE_ALTAS_EXISTENTES,
    payload: axios.get(
      `${constants.BASE_URL}${COMISION_MEMBRESIA_BASE_URL}/integrante-resolucion/membresias-existentes`,
      {
        withCredentials: true,
        params: { periodo }
      }
    ),
    meta: {
      resolver: Promise.resolve
    }
  };
};

export const putReasignarCargoIntegrante = (
  idCotizacionItem: number,
  idMembresiaSocioPersona: number
): IAction => {
  return {
    type: actionTypes.PUT_COMISION_MEMBRESIA_INTEGRANTE_REASIGNAR,
    payload: axios.put(
      `${constants.BASE_URL}${COMISION_MEMBRESIA_BASE_URL}/integrante-resolucion/reasignaciones/${idCotizacionItem}`,
      null,
      {
        withCredentials: true,
        params: { idMembresiaSocioPersona }
      }
    ),
    meta: {
      resolver: Promise.resolve
    }
  };
};

export const clearIntegranteResolucion = (): IAction => {
  return {
    type: actionTypes.CLEAR_COMISION_MEMBRESIA_INTEGRANTE_RESOLUCION,
    payload: true
  };
};
